var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "kanban-tooltip-container" },
    _vm._l(_vm.rows, function (row, index) {
      return _c("table", { key: index, staticClass: "tooltip-row" }, [
        _c("tr", [
          _c("td", { staticClass: "tooltip-label" }, [
            _vm._v(_vm._s(row.text) + ":"),
          ]),
          _c("td", { staticClass: "tooltip-value" }, [
            _vm._v(_vm._s(row.value)),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }